<script>
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default {
    inheritAttrs: false,
    name: 'publish-tooltip-button',
    components: { VTooltipWrapper },
    props: {
        icon: String,
        tooltipText: String,
        openDelay: {
            type: Number,
            default: 350
        }
    }
}
</script>

<template>
    <v-tooltip-wrapper :open-delay="openDelay"
                       tooltip-position="bottom">
        <template #activator="{ on, attrs }">
            <v-btn :aria-label="tooltipText"
                   icon
                   v-bind="{...attrs, ...$attrs, class: $vnode.data.class || $vnode.data.staticClass}"
                   @click="$emit('click', $event)"
                   v-on="{...on}" >
                <v-icon small>{{ icon }}</v-icon>
            </v-btn>
        </template>
        {{ tooltipText }}
    </v-tooltip-wrapper>
</template>

